import useAccountDetails from '../hooks/useAccountDetails';
import { Card, CardHeader, CardTitle, CardBody, CardFooter } from '../../../../components/ui/card';
import { FormRow, FormLabel, FormHelp } from '../../../../components/ui/form';
import { Input } from '../../../../components/ui/input';
import { Select } from '../../../../components/ui/select';
import { Button } from '../../../../components/ui/button';

export type AccountDetailsFormInitialData = {
  firstName: string;
  lastName: string;
  country: string;
  address: Address;
};

export type Address = {
  country: string;
  street: string;
  zip_code: string;
  city: string;
  state: string;
  company: string;
};

interface AccountDetailsFormProps { }

const AccountDetailsForm = (props: AccountDetailsFormProps) => {
  const {
    countryList,
    handleChange,
    handleSubmit,
    formData,
    errors,
    handleBlur,
    isSubmitting,
    touched,
    dirty,
    resetForm,
    isValid,
    disableAddCreditsButton,
    handleRedirectToPaymentPageBasedOnCountry
  } = useAccountDetails();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Billing Details</CardTitle>
      </CardHeader>

      <CardBody>
        <form id="kt_account_profile_details_form" className="form" onSubmit={handleSubmit}>

          {/* First Name */}
          <FormRow>
            <FormLabel required>First Name</FormLabel>
            <div className="col-lg-8 fv-row">
              <Input
                name="firstName"
                placeholder="First name"
                value={formData.firstName}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched.firstName}
                error={errors.firstName}
              />
            </div>
          </FormRow>

          {/* Last Name (Demonstrating different col width) */}
          <FormRow>
            <FormLabel required>Last Name</FormLabel>
            <div className="col-lg-8 fv-row">
              <Input
                name="lastName"
                placeholder="Last name"
                value={formData.lastName}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched.lastName}
                error={errors.lastName}
              />
            </div>
          </FormRow>

          {/* Country */}
          <FormRow>
            <FormLabel>Country</FormLabel>
            <div className="col-lg-8 fv-row">
              <Select
                name="country"
                value={formData.country}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched.country}
                error={errors.country}
              >
                <option value="">Select a Country...</option>
                {countryList.map((c) => (
                  <option key={c.code} value={c.code}>
                    {c.name}
                  </option>
                ))}
              </Select>
            </div>
          </FormRow>

          {/* Footer Actions */}
          <CardFooter className='justify-content-between px-0'>

            {/* Save / Discard */}
            <div className="w-100">
              <button
                type="button"
                className="btn btn-light btn-active-light-primary me-2"
                onClick={() => resetForm()}
                disabled={!dirty || isSubmitting}
              >
                Discard
              </button>

              <button
                type="submit"
                className="btn btn-primary me-2"
                disabled={!dirty || !isValid || isSubmitting}
              >
                {isSubmitting ? 'Saving...' : 'Save'}
              </button>
            </div>

            {/* Credits Action */}
            <div>
              <Button
                variant='secondary'
                size='sm'
                className='me-2 text-white'
                style={{ width: "120px" }}
                disabled={disableAddCreditsButton}
                onClick={handleRedirectToPaymentPageBasedOnCountry}
              >
                Add credits
              </Button>
              {disableAddCreditsButton && (
                <div className="text-center">
                  <FormHelp>(add Country to add credits)</FormHelp>
                </div>
              )}
            </div>
          </CardFooter>
        </form>
      </CardBody>
    </Card>
  );
};

export default AccountDetailsForm;